// extracted by mini-css-extract-plugin
export var active = "_d2-7";
export var container = "_d2-0";
export var evenWidth = "_d2-4";
export var large = "_d2-5";
export var outlet = "_d2-8";
export var slide = "_d2-2";
export var small = "_d2-6";
export var tab = "_d2-3";
export var tabs = "_d2-1";